/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupVault } from '../models/BackupVault';
import { DestinationDetails } from '../models/DestinationDetails';
import { JobExecutionDetails } from '../models/JobExecutionDetails';
import { JobSnapshotDetails } from '../models/JobSnapshotDetails';
import { JobStep } from '../models/JobStep';
import { PartialRestoreData } from '../models/PartialRestoreData';
import { ResourceDetails } from '../models/ResourceDetails';
import { RestoreJobConfiguration } from '../models/RestoreJobConfiguration';
import { RestoreJobType } from '../models/RestoreJobType';

export class RestoreJob {
  'jobExecutionDetails': JobExecutionDetails;
  'resourceDetails'?: ResourceDetails | null;
  'snapshotDetails'?: JobSnapshotDetails | null;
  'destinationDetails': DestinationDetails;
  'partialRestoreData'?: PartialRestoreData | null;
  'vault'?: BackupVault | null;
  'restoreType': RestoreJobType;
  'configuration'?: RestoreJobConfiguration | null;
  /**
  * Indicates whether the job is granular
  */
  'isGranular'?: boolean;
  /**
  * Job steps. Only populated for jobs that have steps available.
  */
  'steps'?: Array<JobStep> | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "jobExecutionDetails",
      "baseName": "jobExecutionDetails",
      "type": "JobExecutionDetails",
      "format": ""
    },
    {
      "name": "resourceDetails",
      "baseName": "resourceDetails",
      "type": "ResourceDetails",
      "format": ""
    },
    {
      "name": "snapshotDetails",
      "baseName": "snapshotDetails",
      "type": "JobSnapshotDetails",
      "format": ""
    },
    {
      "name": "destinationDetails",
      "baseName": "destinationDetails",
      "type": "DestinationDetails",
      "format": ""
    },
    {
      "name": "partialRestoreData",
      "baseName": "partialRestoreData",
      "type": "PartialRestoreData",
      "format": ""
    },
    {
      "name": "vault",
      "baseName": "vault",
      "type": "BackupVault",
      "format": ""
    },
    {
      "name": "restoreType",
      "baseName": "restoreType",
      "type": "RestoreJobType",
      "format": ""
    },
    {
      "name": "configuration",
      "baseName": "configuration",
      "type": "RestoreJobConfiguration",
      "format": ""
    },
    {
      "name": "isGranular",
      "baseName": "isGranular",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "steps",
      "baseName": "steps",
      "type": "Array<JobStep>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreJob.attributeTypeMap;
  }

  public constructor() {
  }
}



